module.exports = __webpack_public_path__ + "img/order_big_tg.dd7697f3.png";